import React, { useCallback, useEffect } from 'react';
import useHome from 'shared/screens/Home/hooks/useHome';
import { GameListContainer, GameListWrapper } from './styledComponents';
import GamePage from '../../components/GamePage';
import { GAME_TRIGGERS } from 'shared/constants';
import { MissionTutorialStepsKeys, shouldChangeTutorialStep } from 'shared/utils/tutorial';
import utils from 'shared/utils';
import TimeRemaining from '../../components/TimeRemaining';
import AccessDenied from '../../components/AccessDenied/AccessDenied';
import FavouritesEmpty from './components/FavouritesEmpty';
import { GAME_ROOMS } from 'shared/screens/Home/constants';

const DynamicHome = ({ navigation, isTutorialActive, tutorialStep, setTutorialStep }) => {
  const homeData = useHome();

  const { activeGameRoomPath, pagedGames, lobbyPromotions, timeRemaining, canEnterRoom, firstTimeAccess } = homeData;

  const handleTutorialStep = useCallback(() => {
    if (isTutorialActive && shouldChangeTutorialStep(tutorialStep)) {
      setTutorialStep(MissionTutorialStepsKeys.CHECK_OUT);
    }
  }, [isTutorialActive, tutorialStep, setTutorialStep]);

  useEffect(() => {
    handleTutorialStep();
  }, [handleTutorialStep]);

  if (!homeData) return null;

  return (
    <div className="roomPage">
      <div className="roomContent">
        {!canEnterRoom && (activeGameRoomPath === GAME_ROOMS.SPORTS || activeGameRoomPath === GAME_ROOMS.VIP) && (
          <AccessDenied canEnterRoom={canEnterRoom} firstTimeAccess={firstTimeAccess} />
        )}
        {canEnterRoom && (
          <GameListWrapper>
            {activeGameRoomPath === GAME_ROOMS.FAVOURITES && utils.isEmpty(pagedGames) && <FavouritesEmpty />}
            {activeGameRoomPath === GAME_ROOMS.VIP && timeRemaining > 0 && (
              <TimeRemaining timeRemaining={timeRemaining} />
            )}
            <GameListContainer>
              {!utils.isEmpty(pagedGames) && (
                <GamePage
                  {...homeData}
                  navigation={navigation}
                  hasPromotions={!utils.isEmpty(lobbyPromotions)}
                  trigger={GAME_TRIGGERS.LOBBY}
                />
              )}
            </GameListContainer>
          </GameListWrapper>
        )}
      </div>
    </div>
  );
};

export default DynamicHome;








